import { AttributeType } from '@containers/ProductListing/model';

export interface IGlamourDay {
  infoPageUrl?: string;
}

export const resolveGlamourDay = (
  attributes?: AttributeType
): IGlamourDay | null => attributes?.GlamourDay ?? null;
